/**
 * Tempos da atualização automática da aba "Meus Estudos" do Flux Personalizado (#2001).
 */

/**
 * Intervalo do polling de status, em ms: a consulta a cada 30 s da nota 4 (`.dc.html:49-50`) e o
 * `refreshSec` padrão do protótipo (`.dc.html:538`).
 */
export const STUDIES_STATUS_POLL_MS = 30000;

/**
 * Duração do destaque da linha que mudou, em ms (`flash`, `.dc.html:605`). É também a espera da
 * regra D06: com filtro de status, a linha que deixou de satisfazê-lo fica na tela durante o
 * destaque e só então a página é refeita.
 */
export const ROW_HIGHLIGHT_MS = 2500;
